import { DarkTooltip } from "@components/DarkTooltip";
import { NationalFlag } from "@components/NationalFlag";
import { useAppSelector } from "@hooks/redux";
import { getRegionIcon } from "@utils/format";

interface LinkedAccountRegionFlagProps {
  region: string;
}

export const LinkedAccountRegionFlag = ({ region }: LinkedAccountRegionFlagProps) => {
  const regionOptions = useAppSelector((state) => state.configReducer.regionOptions);
  const iconUrl = getRegionIcon(regionOptions, region);
  const regionName = regionOptions.find((option) => option.value === region)?.name ?? region;

  if (!iconUrl) {
    return null;
  }

  return (
    <DarkTooltip title={regionName}>
      <div className="flex shrink-0">
        <NationalFlag url={iconUrl} className="size-[16px]! h-[10px]! w-[14px]! border-0" />
      </div>
    </DarkTooltip>
  );
};
